export default __webpack_public_path__ + "static/media/plus.f3eef587.svg";